import Link from 'next/link'

import { Breadcrumbs, Typography, Link as UILink } from '@mui/material'
import { useTheme } from '@mui/system'

import Icon from 'src/@core/components/icon'

type BreadCrumbsData = {
  href?: string
  isActive?: boolean
  text?: string
}

type BreadCrumbsProps = {
  data: BreadCrumbsData[]
  separator?: JSX.Element
}

const BreadCrumbs = ({ data, separator = <Icon icon='tabler:chevron-right' /> }: BreadCrumbsProps) => {
  const theme = useTheme()

  return (
    <Breadcrumbs separator={separator}>
      {data.map((breadcrumb, i) =>
        breadcrumb.isActive ? (
          <Typography key={i} color='text.primary'>
            {breadcrumb.text}
          </Typography>
        ) : (
          <UILink
            component={Link}
            underline='hover'
            key={i}
            color={`${theme.palette.primary.main} !important`}
            href={breadcrumb.href}
          >
            {breadcrumb.text}
          </UILink>
        )
      )}
    </Breadcrumbs>
  )
}

export default BreadCrumbs
